/* Created by Interactive 63 - https://interactive63.com */
/**
 * A small popover built on the HTML `popover` attribute. It renders in the top layer wherever it
 * sits in the DOM, closes on outside click or Escape, and is positioned under its anchor element.
 * The caller places `el` in the DOM, so it is removed together with its owner.
 */
import { h } from './dom';

export interface Popover {
  readonly el: HTMLElement;
  open(): void;
  close(): void;
  isOpen(): boolean;
}

/** Creates a popover holding the given content, anchored to an element. Append `el` yourself. */
export function createPopover(anchor: HTMLElement, content: HTMLElement, label: string): Popover {
  const el = h(
    'div',
    { class: 'popover', popover: 'auto', role: 'dialog', 'aria-label': label },
    content,
  );

  /** Places the popover just below the anchor, kept inside the viewport. */
  const position = (): void => {
    const rect = anchor.getBoundingClientRect();
    const width = el.offsetWidth || 240;
    el.style.left = `${Math.max(8, Math.min(window.innerWidth - width - 8, rect.left))}px`;
    el.style.top = `${rect.bottom + 4}px`;
  };

  return {
    el,
    open: () => {
      if (typeof el.showPopover !== 'function') return;
      el.showPopover();
      position();
    },
    close: () => {
      if (typeof el.hidePopover === 'function' && el.matches(':popover-open')) el.hidePopover();
    },
    isOpen: () => typeof el.matches === 'function' && el.matches(':popover-open'),
  };
}
